module.exports = __webpack_public_path__ + "img/icon_salary.6d6a3948.png";